import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';

const DEFAULT_PROMO_BASE_URL = 'https://pub-df5223fa4cce4bdfaa8306e9b125917d.r2.dev/promo/v1';
const PROMO_BASE_URL = (process.env.REACT_APP_PROMO_BASE_URL || DEFAULT_PROMO_BASE_URL).replace(/\/+$/, '');

export const TRAILER_VIDEO_URL = `${PROMO_BASE_URL}/myshaps-trailer-v5.mp4`;
export const TRAILER_POSTER_URL = `${PROMO_BASE_URL}/myshaps-trailer-v5-poster.jpg`;

// Owns its own error state; it is unmounted whenever the modal closes, so a
// load failure resets on the next open.
const TrailerPlayer = () => {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <div className="flex w-full aspect-video items-center justify-center rounded-md bg-black text-sm text-stone-400">
        Trailer unavailable right now.
      </div>
    );
  }

  return (
    <video
      className="w-full aspect-video rounded-md bg-black"
      src={TRAILER_VIDEO_URL}
      poster={TRAILER_POSTER_URL}
      controls
      autoPlay
      playsInline
      preload="metadata"
      onError={() => setFailed(true)}
    />
  );
};

export const TrailerModal = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        aria-describedby={undefined}
        className="content-center gap-3 bg-stone-900 border-stone-700 text-stone-100 sm:w-[calc(100vw-2rem)] sm:max-w-4xl sm:p-4"
      >
        <DialogHeader className="pr-10">
          <DialogTitle className="text-base text-stone-100">MysHaps trailer</DialogTitle>
        </DialogHeader>
        {/* The `open &&` guard unmounts the player as soon as the dialog closes
            (before Radix's exit animation finishes), which stops playback. */}
        {open && <TrailerPlayer />}
      </DialogContent>
    </Dialog>
  );
};
